module.exports = __webpack_public_path__ + "static/media/partnership-banner.80c80d64.png";